import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export enum AuthenticationType {
    COGNITO_IMPLICIT_FLOW = 'COGNITO_IMPLICIT_FLOW',
}

export type AuthenticationInput = {
    type: AuthenticationType,
    idToken?: string,
    accessToken?: string,
}

export enum ScreenshotStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
}

export type ApplicationScreenshot = {
    id: string,
    url?: string,
    path?: string,
    selector?: string,
    viewportWidth?: number,
    viewportHeight?: number,
    fullPage?: boolean,
    waitForSelector?: string,
    delay?: number,
    deviceScaleFactor?: number,
    hideScrollbars?: boolean,
    authentication?: AuthenticationInput,
    status?: ScreenshotStatus,
    screenshotUrl?: string,
    errorMessage?: string,
    fileSize?: number,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export type ApplicationScreenshotRecordFormProps = {
    record: ApplicationScreenshot,
    handleSubmit: (values: ApplicationScreenshot) => void
    handleCancel: () => void
}

export interface IApplicationScreenshotTableColumn extends ITableColumn {
    render?: (item: ApplicationScreenshot) => ReactNode;
}
